export default __webpack_public_path__ + "static/media/OEM.8d72d27b.jpg";